import { Icon } from '@components/primitives/Icon'
import { Text } from '@components/primitives/Text'
import { classMerge } from '@components/utilities/classMerge'
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck'

export default function ApplySelectOption({
  className,
  label,
  onClick,
  selected,
  value,
}: {
  className?: string
  label: string
  onClick: (value: string) => void
  selected: boolean
  value: string
}) {
  return (
    <div
      className={classMerge(
        'flex w-full cursor-pointer items-center justify-between gap-2 rounded-md border-2 border-neutral200 bg-neutral50 p-4',
        {
          'border-neutral900': selected,
        },
        className,
      )}
      onClick={() => onClick(value)}
    >
      <div className='flex flex-col'>
        <Text
          className='text-neutral900'
          styleName='p-small-strong'
          value={label}
        />
      </div>
      <div
        aria-checked={selected}
        aria-label={label}
        className={classMerge(
          'flex size-6 min-w-6 items-center justify-center rounded border-2 border-neutral900',
          {
            'bg-neutral900': selected,
          },
        )}
        role='checkbox'
      >
        {selected && <Icon className='px-1.5 text-white' icon={faCheck} />}
      </div>
    </div>
  )
}
